module.exports = __webpack_public_path__ + "static/media/telefono.4a4e8108.png";